const initializeCategorySwiper = () => {
  const categoriesSection = document.querySelector(".home-section-categories");
  if (!categoriesSection) return;

  const swiper = new Swiper(".home-section-categories .categories-swiper", {
    loop: false,
    slidesPerView: 1.25,
    spaceBetween: 16,
    breakpoints: {
      500: {
        slidesPerView: 2.25,
      },
      768: {
        slidesPerView: 3.25,
      },
      1200: {
        slidesPerView: 4.25,
      },
      1600: {
        slidesPerView: 5.25,
      },

    },
    navigation: {
      nextEl: ".home-section-categories .categories-swiper .swiper-button-next",
      prevEl: ".home-section-categories .categories-swiper .swiper-button-prev",
    },
    pagination: {
      el: ".home-section-categories .categories-swiper .swiper-pagination",
      clickable: true,
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
  });
};

const initializeBrandSwiper = () => {
  const brandSection = document.querySelector(".home-section-brands");
  if (!brandSection) return;

  const swiper = new Swiper(".home-section-brands .brand-swiper", {
    direction: "horizontal",
    loop: true,
    autoplay: true,
    slidesPerView: 2,
    centeredSlides: true,
    speed: 1000,
    spaceBetween: 40,
    breakpoints: {
      500: {
        slidesPerView: 3,
      },
      650: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 5,
      },
      992: {
        slidesPerView: 6,
      },
      1200: {
        slidesPerView: 7,
      },
    },
  });
};

const initializeReviewsSwiper = () => {
  const reviewsSection = document.querySelector(".home-section-reviews");
  if (!reviewsSection) return;

  const swiper = new Swiper(".home-section-reviews .reviews-swiper", {
    loop: true,
    centeredSlides: true,
    slidesPerView: 1.2,
    spaceBetween: 16,
    breakpoints: {
      768: {
        loop: false,
        centeredSlides: false,
        slidesPerView: 3,
        spaceBetween: 24,
        allowTouchMove: false,
      },
    },
  });
};

const initializeContentPageAnchorLinks = () => {
  const anchorLinks = document.querySelectorAll(
    '.content-page a[href^="#"]'
  );
  if (!anchorLinks.length) return;

  anchorLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      const targetId = link.getAttribute("href").slice(1);
      const target = targetId && document.getElementById(targetId);
      if (!target) return;

      e.preventDefault();

      const headerHeight = document.querySelector("header")?.offsetHeight ?? 0;
      const targetPosition =
        target.getBoundingClientRect().top + window.scrollY - headerHeight;

      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });
    });
  });
};

const setActiveContentPageNavLink = () => {
  const nav = document.querySelector(".design-studio-navigation");
  if (!nav) return;

  const currentPage = [...document.body.classList]
    .find((className) => className.startsWith("page-"))
    ?.replace("page-", "");
  if (!currentPage) return;

  let currentLink = null

  switch (currentPage) {
    case "allure-interiors":
      currentLink = nav.querySelector('.nav-allure-interiors a');
      break;
    case "find-your-style":
      currentLink = nav.querySelector('.nav-get-started a');
      break;
    case "our-team":
      currentLink = nav.querySelector('.nav-design-team a');
      break;
    case "portfolio":
      currentLink = nav.querySelector('.nav-portfolio a');
      break;
    case "contact-us":
      currentLink = nav.querySelector('.nav-contact-us a');
      break;
    default:
      break;
  }

  if (currentLink) {
    currentLink.classList.add("active");
    currentLink.setAttribute("aria-current", "page");
  }
};

const updateToTheTradeForm = () => {
  const form = document.getElementById("toTheTradeForm");
  if (!form) return;

  const comment = form.querySelector("textarea#comments");
  if (comment) {
    comment.placeholder = "Describe current projects"
    comment.rows = 5;
  }

  const submitBtn = form.querySelector(".form-control-submit input.contact-button");
  if (submitBtn) {
    submitBtn.value = "Submit Trade Application";
  }
}

const initializeMattressSwiper = () => {
  const mattressPage = document.querySelector("body.mattresses");
  if (!mattressPage) return;

  const swiper = new Swiper('.size-swiper', {
      direction: "horizontal",
      loop: true,
      autoplay: true,
      slidesPerView: 'auto',
      keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
      navigation: {
          nextEl: '.size-swiper .swiper-button-next',
          prevEl: '.size-swiper .swiper-button-prev',
        },
  })
};

const initializeCollectionLightbox = () => {
  const triggers = document.querySelectorAll(
    ".content-page .treatment-grid .treatment-card-img-btn"
  );
  if (!triggers.length) return;

  const images = [...triggers].map((btn) => {
    const img = btn.querySelector(".treatment-card-img");
    return {
      src: img.dataset.fullSrc || img.getAttribute("src"),
      alt: img.getAttribute("alt") || "",
      caption:
        btn.closest(".treatment-card")?.querySelector("h3")?.textContent?.trim() ?? "",
    };
  });

  const lightbox = document.createElement("div");
  lightbox.className = "collection-lightbox";
  lightbox.setAttribute("role", "dialog");
  lightbox.setAttribute("aria-modal", "true");
  lightbox.setAttribute("aria-hidden", "true");
  lightbox.innerHTML = `
    <div class="collection-lightbox-overlay"></div>
    <div class="collection-lightbox-content">
      <button type="button" class="collection-lightbox-close" aria-label="Close">&times;</button>
      <button type="button" class="collection-lightbox-prev" aria-label="Previous image">&lsaquo;</button>
      <figure class="collection-lightbox-figure">
        <img class="collection-lightbox-img" src="" alt="" />
        <figcaption class="collection-lightbox-caption"></figcaption>
      </figure>
      <button type="button" class="collection-lightbox-next" aria-label="Next image">&rsaquo;</button>
      <div class="collection-lightbox-counter"></div>
    </div>
  `;
  document.body.appendChild(lightbox);

  const imgEl = lightbox.querySelector(".collection-lightbox-img");
  const captionEl = lightbox.querySelector(".collection-lightbox-caption");
  const counterEl = lightbox.querySelector(".collection-lightbox-counter");
  const closeBtn = lightbox.querySelector(".collection-lightbox-close");
  const prevBtn = lightbox.querySelector(".collection-lightbox-prev");
  const nextBtn = lightbox.querySelector(".collection-lightbox-next");

  let currentIndex = 0;
  let lastFocusedEl = null;

  const showImage = (index) => {
    currentIndex = (index + images.length) % images.length;
    const image = images[currentIndex];
    imgEl.src = image.src;
    imgEl.alt = image.alt;
    captionEl.textContent = image.caption;
    counterEl.textContent = `${currentIndex + 1} / ${images.length}`;
  };

  const showPrev = () => showImage(currentIndex - 1);
  const showNext = () => showImage(currentIndex + 1);

  const handleKeydown = (e) => {
    if (e.key === "Escape") closeLightbox();
    if (e.key === "ArrowLeft") showPrev();
    if (e.key === "ArrowRight") showNext();
  };

  const openLightbox = (index) => {
    lastFocusedEl = document.activeElement;
    showImage(index);
    lightbox.classList.add("is-open");
    lightbox.setAttribute("aria-hidden", "false");
    document.body.classList.add("collection-lightbox-open");
    closeBtn.focus();
    document.addEventListener("keydown", handleKeydown);
  };

  const closeLightbox = () => {
    lightbox.classList.remove("is-open");
    lightbox.setAttribute("aria-hidden", "true");
    document.body.classList.remove("collection-lightbox-open");
    document.removeEventListener("keydown", handleKeydown);
    lastFocusedEl?.focus();
  };

  triggers.forEach((btn, index) => {
    btn.addEventListener("click", () => openLightbox(index));
    btn.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        openLightbox(index);
      }
    });
  });

  closeBtn.addEventListener("click", closeLightbox);
  prevBtn.addEventListener("click", showPrev);
  nextBtn.addEventListener("click", showNext);

  const SWIPE_THRESHOLD = 40;
  let touchStartX = null;
  let touchStartY = null;

  lightbox.addEventListener(
    "touchstart",
    (e) => {
      const touch = e.changedTouches[0];
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
    },
    { passive: true }
  );

  lightbox.addEventListener(
    "touchmove",
    (e) => {
      if (touchStartX !== null) e.preventDefault();
    },
    { passive: false }
  );

  lightbox.addEventListener(
    "touchend",
    (e) => {
      if (touchStartX === null) return;
      const touch = e.changedTouches[0];
      const deltaX = touch.clientX - touchStartX;
      const deltaY = touch.clientY - touchStartY;
      touchStartX = null;
      touchStartY = null;

      if (Math.abs(deltaX) < SWIPE_THRESHOLD || Math.abs(deltaX) < Math.abs(deltaY)) return;

      if (deltaX < 0) showNext();
      else showPrev();
    },
    { passive: true }
  );

  lightbox.addEventListener("click", (e) => {
    const isInteractive = e.target.closest(
      ".collection-lightbox-figure, .collection-lightbox-close, .collection-lightbox-prev, .collection-lightbox-next"
    );
    if (!isInteractive) closeLightbox();
  });
};

const addPhillipJeffriesBrandToBrandsSitemap = () => {
  const brandsSitemap = document.querySelector('.brandsSitemap ul')
  if (!brandsSitemap) return;

  if (!brandsSitemap.querySelector('li#brand-phillip-jeffries')) {
    const li = document.createElement('li')
    li.id = 'brand-phillip-jeffries'
    li.innerHTML = `<a href="/wallcoverings" title="Shop Philip Jeffries Wallcoverings">Phillip Jeffries</a>`

    const stearnsFosterLi = brandsSitemap.querySelector('li#brand-stearns-foster')
    if (stearnsFosterLi) {
      brandsSitemap.insertBefore(li, stearnsFosterLi)
    } else {
      brandsSitemap.appendChild(li)
    }
  }
}

const addPhillipJeffriesToBrandPage = () => {
  const brands = document.querySelector('.page-brands .brand-section')
  if (!brands) return;

  if (!brands.querySelector('#brand-phillip-jeffries')) {
    const div = document.createElement('div')
    div.id = 'brand-phillip-jeffries'
    div.className = 'brand-logo'
    div.innerHTML = `
      <a href="/wallcoverings" title="Shop Philip Jeffries Wallcoverings">
        <img src="https://cdn.knorrweb.com/sites/allur/content/a255f98f5d7f34837c986631f4c58c74.webp" alt="Philip Jeffries" class="brand-logo-fit" />
        <h6 class="brand-section-title">Philip Jeffries</h6>
      </a>
    `

    const stearnsFoster = brands.querySelector('#brand-stearns-foster')
    if (stearnsFoster) {
      brands.insertBefore(div, stearnsFoster)
    } else {
      brands.appendChild(div)
    }
  }
}

const updateDesignerEmailButton = () => {
  const designPage = document.querySelector('.design-team.single')
  if (!designPage) return;

  const emailLink = designPage.querySelector('.design-team__contact a.button')
  if (emailLink) {
    emailLink.href = '/design-center#designConsultationForm'
  }
}

document.addEventListener("DOMContentLoaded", () => {
  initializeCategorySwiper();
  initializeBrandSwiper();
  initializeReviewsSwiper();
  initializeContentPageAnchorLinks();
  setActiveContentPageNavLink();
  updateToTheTradeForm();
  initializeMattressSwiper();
  initializeCollectionLightbox();
  addPhillipJeffriesToBrandPage();
  addPhillipJeffriesBrandToBrandsSitemap();
  updateDesignerEmailButton();
});
